export default "__VITE_ASSET__CiuY3SHX__"